import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Action from '@sharedComponents/Action';
import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { keyboardActionHandler } from '@utils/keyboardActionHandler';
import { useState } from 'react';

import * as style from './style.module.css';

/**
 * Page section whose title toggles its content: a chevron shows whether it is open.
 * The content is rendered only while the section is open.
 */
const CollapsibleSection = ({ title, defaultOpen = true, children }) => {
    const [open, setOpen] = useState(defaultOpen);
    const toggle = () => setOpen((value) => !value);

    return (
        <FlexBox flexDirection="column" gap="s">
            <Typography seo={2} fontSize="l" fontWeight="bold" color="neutral-primary">
                <Action
                    role="button"
                    tabIndex={0}
                    aria-expanded={open}
                    className={style.header}
                    action={toggle}
                    onKeyDown={(event) => keyboardActionHandler(event, toggle, ['Enter', ' '])}
                >
                    <FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} fixedWidth className={style.chevron} />
                    {title}
                </Action>
            </Typography>
            {open && children}
        </FlexBox>
    );
};

export default CollapsibleSection;
